import React, { useState } from 'react';
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink as BootstrapNavLink,
  NavbarToggler,
  Collapse,
  Button,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faShieldAlt,
  faPalette,
  faLaptopCode,
  faChartLine,
  faSignOutAlt,
  faMicrochip,
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, NavLink as RouterNavLink } from 'react-router-dom';

const NAVY = '#0A1A33';
const WHITE = '#FFFFFF';
const WHITE_MUTED = 'rgba(255, 255, 255, 0.78)';

const navLinkStyle = {
  color: WHITE_MUTED,
  fontWeight: 500,
  fontSize: '0.95rem',
  display: 'flex',
  alignItems: 'center',
  padding: '0.5rem 1rem',
  transition: 'color 0.2s ease',
};

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { authData, logout, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return null;
  }

  const isLoggedIn = !!authData;
  const toggleNavbar = () => setIsOpen(!isOpen);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const navItems = [
    { to: '/', icon: faHome, label: 'Home', end: true },
    { to: '/ehs', icon: faShieldAlt, label: 'EHS' },
    { to: '/it', icon: faMicrochip, label: 'IT Alerts' },
    { to: '/marketing-materials', icon: faPalette, label: 'Marketing' },
    { to: '/webapps', icon: faLaptopCode, label: 'Web Apps' },
    { to: '/dashboard', icon: faChartLine, label: 'Business Intelligence' },
  ];

  return (
    <Navbar
      dark
      expand="md"
      className="fixed-top"
      style={{
        backgroundColor: NAVY,
        padding: '16px 28px',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
      }}
    >
      <NavbarBrand
        href="/"
        className="d-flex align-items-center"
        style={{ padding: 0 }}
      >
        <img
          src="/axillion-aerospace-logo.svg"
          alt="Axillon Aerospace"
          style={{
            height: 36,
            width: 'auto',
            filter: 'brightness(0) invert(1)',
          }}
        />
      </NavbarBrand>

      <NavbarToggler
        onClick={toggleNavbar}
        className="border-0"
        style={{ filter: 'invert(1)' }}
      />

      <Collapse isOpen={isOpen} navbar>
        <Nav className="ms-auto d-flex align-items-center" navbar>
          {isLoggedIn && (
            <>
              {navItems.map((item) => (
                <NavItem key={item.to}>
                  <BootstrapNavLink
                    tag={RouterNavLink}
                    to={item.to}
                    end={item.end}
                    style={navLinkStyle}
                  >
                    <FontAwesomeIcon
                      icon={item.icon}
                      style={{ marginRight: 8, fontSize: '0.85rem' }}
                    />
                    {item.label}
                  </BootstrapNavLink>
                </NavItem>
              ))}

              <NavItem>
                <Button
                  onClick={handleLogout}
                  style={{
                    backgroundColor: WHITE,
                    color: NAVY,
                    border: 'none',
                    fontWeight: 600,
                    borderRadius: 999,
                    padding: '8px 20px',
                    marginLeft: 12,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <FontAwesomeIcon
                    icon={faSignOutAlt}
                    style={{ marginRight: 8 }}
                  />
                  Logout
                </Button>
              </NavItem>
            </>
          )}
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default Header;
